export default function nameToColorHash(name: string): string {
  const hash = name
    .split("")
    .reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
  const s = 100;
  const l = 30 + (Math.abs(hash) % 11); // L goes from 30 to 40
  const color1 = `hsl(${Math.abs(hash % 360)},${s}%,${l}%)`;

  // color 2 is 25 degrees away from color 1
  const color2 = `hsl(${Math.abs((hash + 45) % 360)},${s}%,${l}%)`;

  return `linear-gradient(45deg, ${color1}, ${color2})`;
}
